import React, { useState, useMemo } from "react";
import { useQuery } from "@apollo/client";
import CommunicationModal from "./CommunicationModal";
import CommuniModal from "./CommuiModal";
import { PlusCircleIcon } from "@heroicons/react/20/solid";
import { XMarkIcon, ArrowUturnLeftIcon } from "@heroicons/react/20/solid";
import gqlPreAuth from "../../../gql/preAuth";

import "../styles/pre-auth.css";
import AppModal from "../../../components/AppModal";
import { MdAttachFile, MdDownload } from "react-icons/md";
import { Button, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import toast from "react-hot-toast";
import { LuReply } from "react-icons/lu";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TableLoader from "../../../common/TableLoader";
import AppButton from "../../../shared/AppButton";
import AppTable from "../../../shared/AppTable";

const CommunicationDetails = ({ item, currentItem }) => {
  const { t, i18n } = useTranslation();
  const [showCommunicationModal, setshowCommunicationModal] = useState(false);
  const [communicationId, setCommunicationId] = useState("");
  const [dataArray, setdataArray] = useState([]);
  const { id } = useParams();

  const {
    loading: communicationLoading,
    error: communicationError,
    data: communicationData,
    refetch: communicationRefetch,
  } = useQuery(gqlPreAuth.GET_TRANSACTION_COMMUNICATIONS, {
    variables: {
      input: {
        transaction_id: currentItem?.transaction_id,
        request_name: "preAuth",
      },
    },
    fetchPolicy: "network-only",
  });

  function downloadBase64File(base64Data, fileName, fileType) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    URL.revokeObjectURL(url);
  }

  const findSequence = (seq) => {
    const findSeq = item?.getPreAuthTransaction?.data?.items?.find(
      (i) => i.sequence_no === seq,
    );
    return findSeq
      ? `${findSeq?.type} - (${findSeq?.standard_code} - ${findSeq?.standard_description})`
      : "___";
  };

  const {
    loading: pollLoading,
    error: pollError,
    data: pollData,
    refetch: refetchPoll,
  } = useQuery(gqlPreAuth.PRE_AUTH_COMMUNICATION_POLL, {
    skip: true,
  });

  const pollClicked = () => {
    toast.loading("Requesting!");
    refetchPoll().then(async (res) => {
      toast.success(res?.data?.pollRequest?.message || "Request Successfully!");
      await communicationRefetch({
        input: {
          transaction_id: currentItem?.transaction_id,
          request_name: "preAuth",
        },
      });
    });
  };

  const flattenedData = useMemo(() => {
    const rawData =
      communicationData?.listCommunicationsByTransactionId?.data || [];
    let rows = [];
    rawData.forEach((mainItem) => {
      mainItem?.payload?.forEach((payloadEl) => {
        rows.push({
          ...payloadEl,
          timestamp: mainItem.timestamp,
          type: mainItem.type,
          creator: mainItem.creator,
          mainId: mainItem.id,
        });
      });
    });
    return rows;
  }, [communicationData]);

  const columns = [
    {
      header: t("Date"),
      render: (row) => (
        <div className="text-xs">
          {new Date(row.timestamp).toLocaleDateString("en-GB")}
          <br />
          {new Date(row.timestamp).toLocaleTimeString("en-GB")}
        </div>
      ),
    },
    { header: t("Type"), field: "type" },
    {
      header: t("Comment/File"),
      render: (row) =>
        row?.payload_comment ? (
          <span className="whitespace-pre-wrap text-xs">
            {row.payload_comment}
          </span>
        ) : (
          <div className="flex items-center gap-2">
            <MdAttachFile className="text-gray-500" />
            <span className="max-w-[150px] truncate text-xs">
              {row?.payload_attachment?.payload_attachment_title}
            </span>
            <MdDownload
              className="cursor-pointer text-[#0070C2] no-print"
              onClick={() => {
                if (row?.payload_attachment?.payload_attachment_url) {
                  window.open(
                    row.payload_attachment.payload_attachment_url,
                    "_blank",
                    "noopener,noreferrer",
                  );
                } else {
                  downloadBase64File(
                    row?.payload_attachment?.payload_attachment_data,
                    row?.payload_attachment?.payload_attachment_title,
                    row?.payload_attachment?.payload_attachment_content_type,
                  );
                }
              }}
            />
          </div>
        ),
    },
    {
      header: t("Item Seq."),
      render: (row) => (
        <span className="text-xs text-gray-600">
          {findSequence(row?.item_sequence)}
        </span>
      ),
    },
    {
      header: t("Reply"),
      render: (row) =>
        row?.creator === "payer" ? (
          <Tooltip title="Reply">
            <div
              onClick={() => {
                setCommunicationId(row.mainId);
                setshowCommunicationModal(true);
              }}
              className="text-xl cursor-pointer text-[#0070C2] hover:scale-110 transition-transform no-print"
            >
              <LuReply />
            </div>
          </Tooltip>
        ) : (
          "--"
        ),
    },
  ];

  return (
    <>
      {communicationLoading ? (
        <div className="mt-2">
          <TableLoader
            columns={5}
            showHeaderButtons={true}
            headerButtonsCount={1}
          />
        </div>
      ) : (
        <div className="pre_auth_communication_page !mt-2">
          <div className="add_communication !p-0 !border-none !shadow-none !bg-transparent">
            <div className="flex justify-end gap-2 mb-2">
              {/* <Button
                variant="contained"
                size="small"
                onClick={() => pollClicked()}
                style={{ backgroundImage: "'linear-gradient(83deg,#007bff)'" }}
                startIcon={<ImportExportIcon />}
              >
                Poll
              </Button> */}
              <AppButton
                label={t("Add Communication")}
                className="no-print"
                onClick={() =>
                  setshowCommunicationModal(!showCommunicationModal)
                }
                startIcon={<AddIcon />}
              />
            </div>

            <AppTable
              columns={columns}
              data={flattenedData}
              loading={communicationLoading}
              actions={false}
            />
          </div>

          <CommuniModal
            dataArray={dataArray}
            item={item}
            currentItem={currentItem}
            setdataArray={setdataArray}
            showCommunicationModal={showCommunicationModal}
            setshowCommunicationModal={setshowCommunicationModal}
            communicationId={communicationId}
            communicationRefetch={communicationRefetch}
          />
        </div>
      )}
    </>
  );
};

export default CommunicationDetails;
